define("ember-svg-jar/inlined/targeted-audience", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<path d=\"M12 12.75c-.85 0-1.563-.287-2.137-.863C9.288 11.313 9 10.6 9 9.75c0-.833.287-1.542.863-2.125.575-.583 1.287-.875 2.137-.875.833 0 1.542.292 2.125.875S15 8.917 15 9.75c0 .85-.292 1.563-.875 2.137-.583.575-1.292.863-2.125.863zm0-2c.283 0 .52-.096.713-.287A.968.968 0 0013 9.75a.967.967 0 00-.287-.713A.968.968 0 0012 8.75a.968.968 0 00-.713.287.967.967 0 00-.287.713c0 .283.096.52.287.713.192.191.43.287.713.287zm-6 8v-1.9c0-.35.088-.68.263-.988.175-.308.412-.554.712-.737.767-.45 1.57-.792 2.412-1.025A9.735 9.735 0 0112 13.75c.9 0 1.77.117 2.613.35.841.233 1.645.575 2.412 1.025.3.183.538.43.713.738.175.308.262.637.262.987v1.9H6zm6-3c-.683 0-1.35.083-2 .25a7.436 7.436 0 00-1.85.75h7.7A7.436 7.436 0 0014 16a8.019 8.019 0 00-2-.25zm0 1h3.85-7.7H12zm-8 6c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 012 20.75v-4h2v4h4v2H4zm-2-14v-4c0-.55.196-1.02.587-1.413A1.926 1.926 0 014 2.75h4v2H4v4H2zm14 14v-2h4v-4h2v4c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0120 22.75h-4zm4-14v-4h-4v-2h4c.55 0 1.02.196 1.413.587.391.392.587.863.587 1.413v4h-2z\"/>",
    "attrs": {
      "width": "24",
      "height": "25",
      "viewBox": "0 0 24 25",
      "fill": "currentColor",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  };
});